/**
 * SubscriptionOnboardingModal - kept for the pages that open it (Account,
 * Subscription). The monthly/annual plans it used to sell no longer exist on
 * this site's Stripe account, so it now opens the one-time checkout
 * (YearAccessModal: 1 Full Year of Access, agreement box, confirmation).
 * The previous version is in git history.
 */

import { YearAccessModal } from './YearAccessModal'

interface SubscriptionOnboardingModalProps {
  isOpen: boolean
  userId: string
  inviteToken: string | null
  onComplete: () => void
  onClose?: () => void // Called when user clicks X button to close modal
  onSkip?: () => void // Called when user clicks skip button
  allowSkip?: boolean // Whether to show skip button
}

export function SubscriptionOnboardingModal({ isOpen, onComplete, onClose }: SubscriptionOnboardingModalProps) {
  return <YearAccessModal isOpen={isOpen} onComplete={onComplete} onClose={onClose} />
}

export default SubscriptionOnboardingModal
